import { useCallback, useRef, useState } from 'react'
import { IconFilter } from 'components/Icons/IconFilter'
import { Menu } from 'components/Menu/Menu'
import { useOnClickOutside } from 'utils/onClickOutside'
import Checkbox from 'components/Checkbox/Checkbox'
import { ActivityHistoryFilterContainer, IconContainer, MenuItem } from './styles'

interface Props {
  onChange: (filterName: string) => void
  filters: Record<string, boolean>
  items: string[]
  disabledFilter?: boolean
}

export const ActivityHistoryFilter = ({ filters, onChange, items, disabledFilter }: Props) => {
  const [isMenuOpen, setMenuOpen] = useState(false)

  const menuNode = useRef<HTMLDivElement>(null)

  const onClose = useCallback(() => setMenuOpen(false), [])

  useOnClickOutside(menuNode, onClose)

  const toggleMenu = useCallback(() => setMenuOpen(!isMenuOpen), [isMenuOpen])

  const handleMenuItemClick = useCallback(
    (filterName: string) => {
      onClose()
      onChange(filterName)
    },
    [onChange, onClose]
  )

  return (
    <ActivityHistoryFilterContainer>
      <IconContainer onClick={toggleMenu} $disabled={disabledFilter}>
        <IconFilter isActive={!!Object.keys(filters).find(k => !filters[k])} />
      </IconContainer>
      {isMenuOpen && (
        <Menu anchorElement={menuNode} style={{ width: 300, zIndex: 1 }}>
          {items.map(item => (
            <MenuItem key={item} onClick={() => handleMenuItemClick(item)}>
              {item} <Checkbox checked={filters[item]} />
            </MenuItem>
          ))}
        </Menu>
      )}
    </ActivityHistoryFilterContainer>
  )
}
